import React from 'react';
import { ReactComponent as WarningIcon } from '../../assets/svg/warning_amber.svg';
import styles from './ClearModal.module.scss';
import Modal from "../Modal";

interface IProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title?: string;
    bodyText?: string;
}

const ClearModal: React.FC<IProps> = ({ open, onClose, onConfirm, title, bodyText }) => {
    if (!open) return null;

    return (
        <Modal
            onBackdropClick={onClose}
            className={styles.modalContent}
        >
            <div className={styles.header}>
                <WarningIcon className={styles.warningIcon} />
                <h1 className={styles.title}>{title}</h1>
            </div>
            {bodyText && <p className={styles.body}>{bodyText}</p>}
            <div className={styles.buttons}>
                <button
                    type="button"
                    onClick={onClose}
                    className={styles.cancelButton}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={onConfirm}
                    className={styles.clearButton}
                >
                    Yes
                </button>
            </div>
        </Modal>
    );
};

export default ClearModal;